import type { SfmResourceProps } from 'src/AppScopes'
import { SfmList, SfmCreate, SfmEdit, SfmResource } from 'src/AppScopes'
import { CustomDatagrid } from 'src/components/CustomDatagrid'
import { SfmTextField } from 'src/components/SfmFields'
import { RoleEnum } from 'src/UserIdentity'

import { EntitlementForm } from '../Form'

import { Show } from './Show'

export function HabilitationResource(props: SfmResourceProps) {
  return (
    <SfmResource
      {...props}
      show={Show}
      list={(listProps) => (
        <SfmList {...listProps} acceptedEditRoles={[RoleEnum.ROLE_ADMIN]}>
          <CustomDatagrid>
            <SfmTextField source="name" label="resource.entitlements.name" />
          </CustomDatagrid>
        </SfmList>
      )}
      create={(createProps) => (
        <SfmCreate {...createProps} acceptedRoles={[RoleEnum.ROLE_ADMIN]}>
          <EntitlementForm />
        </SfmCreate>
      )}
      edit={(editProps) => (
        <SfmEdit {...editProps} acceptedRoles={[RoleEnum.ROLE_ADMIN]}>
          <EntitlementForm />
        </SfmEdit>
      )}
    />
  )
}
